<div style="padding: 0" *ngIf="full">
  <!--Live Minesites-->
  <ng-container *ngIf="live">
    <div class="panel-group">
      <div
        class="panel"
        [class.minesite-panel]="minesite.Active"
        [class.panel-warning1]="!minesite.Active"
      >
        <div class="panel-heading">
          <h5 style="display: inline-block">
            <span [ngClass]="textColor">{{ label }}</span>
          </h5>
          <div class="pull-right btn-toolbar" role="toolbar">
            <div class="btn-group btn-group-sm">
              <button
                type="button"
                class="btn btn-info"
                data-toggle="collapse"
                title="Expand Mine Site"
                (click)="getEquipment()"
              >
                <span
                  data-toggle="tooltip"
                  class="fa fa-lg"
                  [class.fa-chevron-down]="!equipmentVisible"
                  [class.fa-chevron-up]="equipmentVisible"
                ></span>
              </button>
              <button
                type="button"
                class="btn btn-info"
                data-toggle="modal"
                title="Mine Site Details"
                (click)="details()"
              >
                <span data-toggle="tooltip" class="fa fa-list-alt fa-lg"></span>
              </button>
            </div>
            <ng-container *ngIf="minesite.Active">
              <div class="btn-group btn-group-sm" *ngIf="!live">
                <button
                  type="button"
                  class="btn btn-info"
                  title="Edit Mine Site"
                  (click)="edit()"
                >
                  <span data-toggle="tooltip" class="fa fa-edit fa-lg"></span>
                </button>
                <button
                  type="button"
                  class="btn btn-info"
                  title="Remove Mine Site"
                  (click)="delete()"
                >
                  <span
                    data-toggle="tooltip"
                    class="fa fa-trash-o fa-lg"
                  ></span>
                </button>
              </div>
            </ng-container>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-collapse collapse" [class.in]="equipmentVisible">
          <div class="panel-body" *ngIf="equipmentVisible">
            <div class="list-group">
              <div *ngIf="IsLoading">
                <div style="width: 100%; text-align: center">
                  <span style="color: darkred">Loading {{Progress}}...</span>
                  <i
                    class="fa fa-spinner fa-spin fa-pulse fa-2x"
                    style="color: darkred"
                  ></i>
                </div>
              </div>
              <!--This is displayed on live and staging tab-->
              <equipment-entity
                [live]="live"
                [equipment]="equipment"
                [simplified]="true"
                *ngFor="let equipment of equipment"
              ></equipment-entity>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--End Live Minesites-->
  <!--Staging Minesites-->
  <ng-container *ngIf="!live">
    <div class="panel-group">
      <div
        class="panel"
        [class.minesite-panel]="minesite.Active"
        [class.panel-warning1]="!minesite.Active"
      >
        <div
          [class.panel-heading]="minesite.Status==0"
          [class.panel-Staged]="(minesite.Status==1 || minesite.Status==2)"
          cdkDropList
          [cdkDropListData]="equipment"
          (cdkDropListDropped)="cdkDropEventTriggered($event)"
        >
          <div
            class="panel"
            [class.inner-panel]="minesite.Active"
            [class.panel-Staged]="(minesite.Status==1 || minesite.Status==2)"
            [class.panel-warning1]="!minesite.Active"
            cdkDrag
            [cdkDragData]="minesite"
          >
            <div
              [class.panel-heading]="minesite.Status==0"
              [class.panel-Staged]="(minesite.Status==1 || minesite.Status==2)"
              [class.panel-warning1]="(minesite.Status==4 || minesite.Status==6)"
              [attr.data-minesite-id]="minesite.Minesite_ID"
            >
              <h5 style="display: inline-block; color: white">
                <span [ngClass]="textColor">{{ label }}</span>
              </h5>
              <div class="pull-right btn-toolbar" role="toolbar">
                <div class="btn-group btn-group-sm">
                  <button
                    type="button"
                    class="btn btn-info"
                    data-toggle="collapse"
                    title="Expand Mine Site"
                    (click)="getEquipment()"
                  >
                    <span
                      data-toggle="tooltip"
                      class="fa fa-lg"
                      [class.fa-chevron-down]="!equipmentVisible"
                      [class.fa-chevron-up]="equipmentVisible"
                    ></span>
                  </button>
                  <button
                    type="button"
                    class="btn btn-info"
                    data-toggle="modal"
                    title="Mine Site Details"
                    (click)="details()"
                  >
                    <span
                      data-toggle="tooltip"
                      class="fa fa-list-alt fa-lg"
                    ></span>
                  </button>
                </div>
                <div class="btn-group btn-group-sm" *ngIf="!live">
                  <button
                    type="button"
                    class="btn btn-info"
                    title="Edit Mine Site"
                    (click)="edit()"
                  >
                    <span data-toggle="tooltip" class="fa fa-edit fa-lg"></span>
                  </button>
                  <button
                    type="button"
                    class="btn btn-info"
                    title="Remove Mine Site"
                    (click)="delete()"
                  >
                    <span
                      data-toggle="tooltip"
                      class="fa fa-trash-o fa-lg"
                    ></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="panel-collapse collapse" [class.in]="equipmentVisible">
        <div class="panel-body" *ngIf="equipmentVisible">
          <div class="list-group">
            <div *ngIf="IsLoading">
              <div style="width: 100%; text-align: center">
                <span style="color: darkred">Loading {{Progress}}...</span>
                <i
                  class="fa fa-spinner fa-spin fa-pulse fa-2x"
                  style="color: darkred"
                ></i>
              </div>
            </div>
            <!-- no clue when this is displayed, not on live or staging tab-->
            <equipment-entity
              [live]="live"
              [equipment]="equipment"
              [simplified]="true"
              *ngFor="let equipment of equipment"
            ></equipment-entity>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<!--End Staging Minesites-->

<div
  *ngIf="simplified"
  class="panel"
  [class.minesite-panel]="minesite.Active"
  [class.panel-warning]="!minesite.Active"
  style="margin: 0"
>
  <div
    [class.panel-heading]="minesite.Status==0 || live"
    [class.panel-Staged]="(minesite.Status==1 || minesite.Status==2)"
    [class.panel-warning1]="(minesite.Status==4 || minesite.Status==2 || minesite.Status==6)"
  >
    <h5 style="display: inline-block; color: white">
      <span>{{ minesite.Name }}</span>
    </h5>
    <div class="pull-right btn-toolbar" role="toolbar">
      <div class="btn-group btn-group-sm">
        <button
          type="button"
          class="btn btn-info"
          data-toggle="collapse"
          title="Expand Mine Site"
          (click)="getEquipment()"
        >
          <span
            data-toggle="tooltip"
            class="fa fa-lg"
            [class.fa-chevron-down]="!equipmentVisible"
            [class.fa-chevron-up]="equipmentVisible"
          ></span>
        </button>
      </div>
      <div class="btn-group btn-group-sm" *ngIf="!live && minesite.Status!=4">
        <button
          type="button"
          class="btn btn-info"
          title="Remove Minesite"
          (click)="removeAssociation()"
        >
          <span class="fa fa-minus fa-lg"></span>
        </button>
      </div>
    </div>
  </div>
  <div class="panel-collapse collapse" [class.in]="equipmentVisible">
    <div class="panel-body" *ngIf="equipmentVisible">
      <div class="list-group">
        <equipment-entity
          [live]="live"
          [equipment]="equipment"
          [simplified]="true"
          *ngFor="let equipment of equipment"
        ></equipment-entity>
      </div>
    </div>
  </div>
</div>
<tr *ngIf="detail">
  <td>{{ minesite.Name}}</td>
  <td>{{ equipment.length }}</td>
</tr>

<div
  bsModal
  #DeleteMinesite="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ keyboard: false, backdrop: 'static' }"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Delete Minesite</h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            Are you sure you want to Delete this Minesite:
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-warning"
          type="button"
          (click)="DeleteSelectedMinesite()"
        >
          Confirm Delete
        </button>
        <button class="btn btn-primary" type="button" (click)="Close()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
